import * as Sentry from '@sentry/react';

import { APP_VERSION, getConfig, isDevelopment } from './config';

const DEFAULT_DSN =
  'https://b3f9eb472f65ee9b58074ed43c73010d@o1423748.ingest.us.sentry.io/4511287017144320';

/** Taux d’échantillonnage des transactions / traces (prod). */
const TRACES_SAMPLE_RATE_PRODUCTION = 0.1;
/** Taux d’échantillonnage des erreurs (prod). */
const ERROR_SAMPLE_RATE_PRODUCTION = 0.25;
const CEF_SHARP_OBJECT_NOT_FOUND_ERROR =
  /Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/;
const FIREFOX_NS_ERROR_ABORT_NO_MESSAGE = /^NS_ERROR_ABORT: No error message$/;

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN || DEFAULT_DSN;
  const { apiUrl } = getConfig();

  Sentry.init({
    dsn,
    environment: isDevelopment ? 'development' : 'production',
    // Prefer the CI-provided release when set (lets us match server-uploaded
    // source maps); otherwise fall back to the package.json semver so every
    // issue is still attached to a meaningful version.
    release: import.meta.env.VITE_SENTRY_RELEASE || APP_VERSION,
    integrations: (defaults) => [
      ...defaults,
      Sentry.browserTracingIntegration(),
    ],
    sampleRate: isDevelopment ? 1.0 : ERROR_SAMPLE_RATE_PRODUCTION,
    tracesSampleRate: isDevelopment ? 1.0 : TRACES_SAMPLE_RATE_PRODUCTION,
    ignoreErrors: [
      CEF_SHARP_OBJECT_NOT_FOUND_ERROR,
      FIREFOX_NS_ERROR_ABORT_NO_MESSAGE,
    ],
    // Propagate `sentry-trace` / `baggage` to our GraphQL API so backend
    // spans get linked to frontend transactions when the API is also
    // Sentry-instrumented.
    tracePropagationTargets: [apiUrl, /\/graphql$/],
    sendDefaultPii: false,
  });

  Sentry.setTag('app', 'offers-management');
  Sentry.setTag('app.version', APP_VERSION);
}
